import { applyDecorators } from '@nestjs/common';
import { ApiProperty, ApiPropertyOptional, ApiPropertyOptions } from '@nestjs/swagger';
import { IsOptional, registerDecorator } from 'class-validator';

import { BaseDecoratorOptions } from '../types';

type PropertyRecordParams = {
  validate?: (property: any) => void;
} & BaseDecoratorOptions<Record<string, any>>;

function getRecordValidator(validate: (property: any) => void): PropertyDecorator {
  return (object: Object, propertyName: string | symbol) =>
    registerDecorator({
      propertyName: propertyName.toString(),
      target: object.constructor,
      validator: {
        validate: (value) => {
          Object.keys(value).forEach((key) => {
            const property = value[key];
            if (validate) {
              validate(property);
            }
            value[key] = property;
          });
          return true;
        },
      },
    });
}

export function ApiPropertyRecord({ isOptional, validate, ...options }: PropertyRecordParams = {}): PropertyDecorator {
  const propertyOptions: ApiPropertyOptions = {
    type: 'object',
    additionalProperties: true,
    ...options,
  };

  return applyDecorators(
    ...(isOptional ? [IsOptional(), ApiPropertyOptional(propertyOptions)] : [ApiProperty(propertyOptions)]),
    ...(validate ? [getRecordValidator(validate)] : []),
  );
}
